import { defineComponent } from 'vue';
import useDialogPluginComponent from 'quasar/src/composables/use-dialog-plugin-component/use-dialog-plugin-component.js';
export default defineComponent({
    name: 'custom-warnings',
    props: {
        text: String,
        type: String,
        headerText: {
            type: String,
            default: 'Warning'
        },
        nonPersistent: Boolean,
        okBtnLabel: {
            type: String,
            default: 'Confirm'
        },
        cancelBtnLabel: {
            type: String,
            default: 'Close'
        },
    },
    emits: [
        ...useDialogPluginComponent.emits
    ],
    setup() {
        // standard quasar custom prompt
        const { dialogRef, onDialogHide, onDialogOK, onDialogCancel } = useDialogPluginComponent();
        return {
            dialogRef,
            onDialogHide,
            onOKClick() {
                onDialogOK();
            },
            onCancelClick: onDialogCancel
        };
    }
});
